import { useState, useEffect, useCallback } from 'react';
import Button from '../components/Button';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { SaveFour, GetWD } from '../utils/bridge';
import Spinner  from '../utils/Spinner';
import { useGoToStep } from '../hooks/useGoToStep';
import { logMessage } from '../hooks/logger';

import toast, { Toaster } from 'react-hot-toast';

import { useInputChanged } from '../context/InputChangedContext';

const Paso4 = ({ usr }) => {

    const { setInputChanged, setValidDataInputs } = useInputChanged();

    const [formData, setFormData] = useState({        
        ver: '',
        oir: '',
        caminar: '',
        recordar: '',
        vestir: '',
        comunicar: '',
        levantar: '',
        mano: '',
        ansia: '',
        triste: '',
        certificado: '',
        correouser: usr,        
        result: ['', '']  
    });


     const [validError, setValidError] = useState('');    
     const [isInitialLoad, setInitialLoad] = useState(true);


      useEffect(() => {
            if (usr) {
                setFormData((prevState) => ({
                    ...prevState,
                    correouser: usr
                }));
            }
        }, [usr]);


    const [isUnsave, setIsUnsave] = useState(false);
    const navigate = useNavigate();


     useEffect(() => {
        setIsUnsave(
            formData.ver !== '' || formData.oir !== '' || formData.caminar !== ''
            || formData.recordar !== '' || formData.vestir !== '' || formData.comunicar !== '' || formData.levantar !== ''
            || formData.mano !== '' || formData.ansia !== '' || formData.triste !== '' || formData.certificado !== ''
        );

        //console.log(formData);
    }, [formData]);

    useEffect(() => {
                    
        const unsave = 
            formData.ver !== '' || formData.oir !== '' || formData.caminar !== ''
            || formData.recordar !== '' || formData.vestir !== '' || formData.comunicar !== '' || formData.levantar !== ''
            || formData.mano !== '' || formData.ansia !== '' || formData.triste !== '' || formData.certificado !== ''

        setInputChanged(unsave);

        // calcula si el formulario está completo
        const valid = 
        !!formData.ver.trim() ||
        !!formData.oir.trim() ||
        !!formData.caminar.trim() ||
        !!formData.recordar.trim() ||        
        !!formData.vestir.trim() ||
        !!formData.comunicar.trim() ||
        !!formData.levantar.trim() ||
        !!formData.mano.trim() ||
        !!formData.ansia.trim() ||
        !!formData.certificado.trim();

        setValidDataInputs(valid);
    }, [formData, setInputChanged, setValidDataInputs]);
    


    const handleChange = (e) => {
        const { name, value } = e.target;
              
         setFormData((prevState) => ({
                      ...prevState,
                      [name]: value
         }));        
    };


     const validateError = () => {
        const errors = {};                
        if (!formData.ver.trim()) errors.ver = 'Completar el campo dificultad para ver es obligatorio';
        if (!formData.oir.trim()) errors.oir = 'Completar el campo dificultad para oir es obligatorio';
        if (!formData.caminar.trim()) errors.caminar = 'Completar el campo dificultad para caminar es obligatorio';
        if (!formData.recordar.trim()) errors.recordar = 'Completar el campo dificultad para recordar es obligatorio';
        if (!formData.vestir.trim() ) errors.vestir = 'Completar el campo dificultad para vestirse es obligatorio';
        if (!formData.comunicar.trim()) errors.comunicar = 'Completar el campo dificultad para comunicar es obligatorio';        
        if (!formData.levantar.trim()) errors.levantar = 'Completar el campo dificultad para levantar una botella es obligatorio';        
        if (!formData.mano.trim()) errors.mano = 'Completar el campo dificultad en las manos es obligatorio';        
        if (!formData.ansia.trim()) errors.ansia = 'Completar el campo si siente mucha ansiedad es obligatorio';        
        if (!formData.triste.trim()) errors.triste = 'Completar el campo si siente mucha tristeza es obligatorio';        
        if (!formData.certificado.trim()) errors.certificado = 'Completar el campo si tiene un certificado es obligatorio';        

        return errors;
    }

   
    /*const handleSubmit = async (e) => {
        e.preventDefault();


        const errors = validateError();
        if (Object.keys(errors).length > 0) {
            setValidError(errors);
            return;
        }

        setValidError({});                

        const save = async () => {  
            setInitialLoad(true);          
            try {                                                
                const res = await axios.post(`${SaveFour}`, formData); 
                //console.log(res)                
                toast.success(`${res.data.datos}`);                
            } catch (error) {
                if (error.response) {                    
                    console.log(error.response.data.mensajeError)
                    const errorMessage = error.response.data.mensajeError;
                    logMessage('Error', '⚠ Paso 4: Error del servidor (4xx,5xx):', errorMessage);
                    toast.error(`${errorMessage}`);
                } else {
                    toast.error(`Error: sin respuesta del servidor`);
                }

            }finally{
                setInitialLoad(false); 
            }
        }
          
        save();
        
    }*/

    const save = useCallback(async () => {
        setInitialLoad(true);
        try {
            const res = await axios.post(`${SaveFour}`, formData);
            toast.success(`${res.data.datos}`);
        } catch (error) {
            toast.error("Error al guardar los datos");
            const errorMessage = error.response.data.mensajeError;
                    logMessage('Error', '⚠ Paso 4: Error del servidor (4xx,5xx):', errorMessage);
        } finally {
            setInitialLoad(false);
        }
    }, [formData]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateError();
        if (Object.keys(errors).length > 0) {
            setValidError(errors);
            return;
        }

        setValidError({});
        
        await save();
    };

    const { setSaveFn } = useInputChanged();
    useEffect(() => {
        setSaveFn(() => save);
    }, [save, setSaveFn]);


     const InitialLoad = async () => {
        
        const responseGet =  axios.get(`${GetWD}/${usr}`).then(response => {
            if (response.data) {
                setFormData({ ...formData, ...response.data });                    
            }
        }).catch(error => {
            if (error.response) {
                console.error('⚠ Error del servidor (4xx,5xxg):', error.response.status);
            } else if (error.request) {
                console.error('No se pudo conectar (API caída, red, CORS bloqueadog)');
            } else {
                console.error('Error desconocidog: ', error.message);
                logMessage('Error', '⚠ Paso 4: Error desconocido:', error.message);
            }
        });

        setInitialLoad(false);
    }


     useEffect(() => {
    
            if (isInitialLoad) {
                 InitialLoad();
            }
    
        }, []);
        
        
        const validDataInputs =            
            !!formData.ver.trim() ||
            !!formData.oir.trim() ||
            !!formData.caminar.trim() ||
            !!formData.recordar.trim() ||        
            !!formData.vestir.trim() ||
            !!formData.comunicar.trim() ||
            !!formData.levantar.trim() ||
            !!formData.mano.trim() ||
            !!formData.ansia.trim() ||
            !!formData.certificado.trim();
                
    
        // Hook global para navegación entre pasos
        const { goToStep, ConfirmModal, IncompleteModal } = useGoToStep(save);
        //const goToStep = useGoToStep(validDataInputs);
        //const handleNext = (e) => goToStep(e, "paso3");
        //const handleBack = (e) => goToStep(e, "paso3");
        
        const oldhandleNext = (e) => {
            e.preventDefault();
            console.log("validar")
            console.log(formData)
    
            if (validDataInputs) {
                const confirm = window.confirm(
                    'Cambios detectados en el formulario. ¿Seguro que desea continuar sin guardar?'
                );
                if (!confirm) {
                    e.preventDefault();
                    return;
                } else {
                    navigate("/paso4");
                }
            }
            navigate("/paso4");
        };
    
    
      if (isInitialLoad) return <Spinner />;


    return (
        <div>
            <div className="encab-contenido">
                <h1>Actualización de datos personales y laborales</h1>
            </div>


            <div className="pasos">
                <Link /*to="/paso3"*/ className="ant" onClick={(e)=> goToStep(e, "paso3")}><span className="visually-hidden">Ir al paso</span> <span className="visually-hidden d-lg-block">Anterior</span></Link>
                <h2>Paso 4 de 4</h2>
                <Link /*to="/paso4"*/ className="sig deshab"><span className="visually-hidden">Ir al paso</span> <span className="visually-hidden d-lg-block">Siguiente</span></Link>
            </div>


            <h3>Información de salud</h3>

            <form>
                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="difVision" className=" mb-3">
                            <legend id="difVision">1. ¿Tiene dificultad o limitación <u>para ver</u>, incluso cuando usa lentes?</legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difVision-opc1"
                                    name="ver"
                                    checked={formData.ver === 'R1'}
                                    value="R1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difVision-opc1"> No, ninguna dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difVision-opc2"
                                    name="ver"
                                    checked={formData.ver === 'R2'}
                                    value="R2"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difVision-opc2"> Sí, cierta dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difVision-opc3"
                                    name="ver"
                                    checked={formData.ver === 'R3'}
                                    value="R3"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difVision-opc3"> Sí, mucha dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difVision-opc4"
                                    name="ver"
                                    checked={formData.ver === 'R4'}
                                    value="R4"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difVision-opc4"> No puedo hacerlo. </label>
                            </div>
                        </fieldset>
                    </div>
                      <div id="ayuda-formato-tipo" className="form-text">
                            <p style={{ color: validError.ver ? 'red' : 'gray' }}>
                                {validError.ver ? validError.ver : ''}
                            </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="difdAudicion" className="mb-3">
                            <legend id="difdAudicion">2. ¿Tiene dificultad o limitación <u>para oir</u>, incluso cuando usa aparatos auditivos?</legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difdAudicion-opc1"
                                    name="oir"
                                    checked={formData.oir === 'R1'}
                                    value="R1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difdAudicion-opc1"> No, ninguna dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difdAudicion-opc2"
                                    name="oir"
                                    checked={formData.oir === 'R2'}
                                    value="R2"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difdAudicion-opc2"> Sí, cierta dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difdAudicion-opc3"
                                    name="oir"
                                    checked={formData.oir === 'R3'}
                                    value="R3"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difdAudicion-opc3"> Sí, mucha dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difdAudicion-opc4"
                                    name="oir"
                                    checked={formData.oir === 'R4'}
                                    value="R4"                                    
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difdAudicion-opc4"> No puedo hacerlo. </label>
                            </div>
                        </fieldset>
                    </div>
                     <div id="ayuda-formato-tipo" className="form-text">
                            <p style={{ color: validError.oir ? 'red' : 'gray' }}>
                                {validError.oir ? validError.oir : ''}
                            </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="difCaminar" className="mb-3">
                            <legend id="difCaminar">3. ¿Tiene dificultad o limitación <u>para caminar o subir escalones</u>?</legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difCaminar-opc1"
                                    name="caminar"
                                    checked={formData.caminar === 'R1'}
                                    value="R1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difCaminar-opc1"> No, ninguna dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difCaminar-opc2"
                                    name="caminar"
                                    checked={formData.caminar === 'R2'}
                                    value="R2"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difCaminar-opc2"> Sí, cierta dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difCaminar-opc3"
                                    name="caminar"
                                    checked={formData.caminar === 'R3'}
                                    value="R3"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difCaminar-opc3"> Sí, mucha dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difCaminar-opc4"
                                    name="caminar"
                                    checked={formData.caminar === 'R4'}
                                    value="R4"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difCaminar-opc4"> No puedo hacerlo. </label>
                            </div>
                        </fieldset>
                    </div>
                        <div id="ayuda-formato-tipo" className="form-text">
                            <p style={{ color: validError.caminar ? 'red' : 'gray' }}>
                                {validError.caminar ? validError.caminar : ''}
                            </p>
                        </div>
                </div>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="difConcentrar" className="mb-3">
                            <legend id="difConcentrar">4. ¿Tiene dificultad o limitación <u>para recordar o concentrarse</u>?</legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difConcentrar-opc1"
                                    name="recordar"
                                    checked={formData.recordar === 'R1'}
                                    value="R1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difConcentrar-opc1"> No, ninguna dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difConcentrar-opc2"
                                    name="recordar"
                                    checked={formData.recordar === 'R2'}
                                    value="R2"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difConcentrar-opc2"> Sí, cierta dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difConcentrar-opc3"
                                    name="recordar"
                                    checked={formData.recordar === 'R3'}
                                    value="R3"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difConcentrar-opc3"> Sí, mucha dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difConcentrar-opc4"
                                    name="recordar"
                                    checked={formData.recordar === 'R4'}
                                    value="R4"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difConcentrar-opc4"> No puedo hacerlo. </label>
                            </div>
                        </fieldset>
                    </div>
                        <div id="ayuda-formato-tipo" className="form-text">
                            <p style={{ color: validError.recordar ? 'red' : 'gray' }}>
                                {validError.recordar ? validError.recordar : ''}
                            </p>
                        </div>
                </div>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="difCuidadoPersonal" className="mb-3">
                            <legend id="difCuidadoPersonal">5. ¿Tiene dificultad o limitación <u>para bañarse o vestirse</u> (gestionar su autosuficiencia para el cuidado personal)?</legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difCuidadoPersonal-opc1"
                                    name="vestir"
                                    checked={formData.vestir === 'R1'}
                                    value="R1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difCuidadoPersonal-opc1"> No, ninguna dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difCuidadoPersonal-opc2"
                                    name="vestir"
                                    checked={formData.vestir === 'R2'}
                                    value="R2"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difCuidadoPersonal-opc2"> Sí, cierta dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difCuidadoPersonal-opc3"
                                    name="vestir"
                                    checked={formData.vestir === 'R3'}
                                    value="R3"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difCuidadoPersonal-opc3"> Sí, mucha dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difCuidadoPersonal-opc4"
                                    name="vestir"
                                    checked={formData.vestir === 'R4'}
                                    value="R4"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difCuidadoPersonal-opc4"> No puedo hacerlo. </label>
                            </div>
                        </fieldset>
                    </div>
                    <div id="ayuda-formato-tipo" className="form-text">
                            <p style={{ color: validError.vestir ? 'red' : 'gray' }}>
                                {validError.vestir ? validError.vestir : ''}
                            </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="difComunicarse" className="mb-3">
                            <legend id="difComunicarse">6. ¿Tiene dificultad para comunicarse, por ejemplo, entender a los demás o que lo entiendan a usted, cuando usa un lenguaje normal (habitual)?</legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difComunicarse-opc1"
                                    name="comunicar"
                                    checked={formData.comunicar === 'R1'}
                                    value="R1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difComunicarse-opc1"> No, ninguna dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difComunicarse-opc2"
                                    name="comunicar"
                                    checked={formData.comunicar === 'R2'}
                                    value="R2"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difComunicarse-opc2"> Sí, cierta dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difComunicarse-opc3"
                                    name="comunicar"
                                    checked={formData.comunicar === 'R3'}
                                    value="R3"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difComunicarse-opc3"> Sí, mucha dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difComunicarse-opc4"
                                    name="comunicar"
                                    checked={formData.comunicar === 'R4'}
                                    value="R4"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difComunicarse-opc4"> No puedo hacerlo. </label>
                            </div>
                        </fieldset>
                    </div>
                     <div id="ayuda-formato-tipo" className="form-text">
                            <p style={{ color: validError.comunicar ? 'red' : 'gray' }}>
                                {validError.comunicar ? validError.comunicar : ''}
                            </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="difLevantamiento" className="mb-3">
                            <legend id="difLevantamiento">7. ¿Tiene dificultad para levantar una botella de 2 litros de agua o refresco desde la cintura hasta la altura de los ojos?</legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difLevantamiento-opc1"
                                    name="levantar"
                                    checked={formData.levantar === 'R1'}
                                    value="R1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difLevantamiento-opc1"> No, ninguna dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difLevantamiento-opc2"
                                    name="levantar"
                                    checked={formData.levantar === 'R2'}
                                    value="R2"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difLevantamiento-opc2"> Sí, cierta dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difLevantamiento-opc3"
                                    name="levantar"
                                    checked={formData.levantar === 'R3'}
                                    value="R3"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difLevantamiento-opc3"> Sí, mucha dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difLevantamiento-opc4"
                                    name="levantar"
                                    checked={formData.levantar === 'R4'}
                                    value="R4"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difLevantamiento-opc4"> No puedo hacerlo. </label>
                            </div>
                        </fieldset>
                    </div>
                    <div id="ayuda-formato-tipo" className="form-text">
                            <p style={{ color: validError.levantar ? 'red' : 'gray' }}>
                                {validError.levantar ? validError.levantar : ''}
                            </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="difManos" className="mb-3">
                            <legend id="difManos">8. ¿Tiene dificultad para usar sus manos y dedos? Por ejemplo, al recoger objetos pequeños como un botón o un lápiz, o al abrir y cerrar recipientes o botellas?</legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difManos-opc1"
                                    name="mano"
                                    checked={formData.mano === 'R1'}
                                    value="R1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-difManos-opc1"> No, ninguna dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difManos-opc2"
                                    name="mano"
                                    checked={formData.mano === 'R2'}
                                    value="R2"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />

                                <label className="form-check-label" htmlFor="radio-difManos-opc2"> Sí, cierta dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difManos-opc3"
                                    name="mano"
                                    checked={formData.mano === 'R3'}
                                    value="R3"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />

                                <label className="form-check-label" htmlFor="radio-difManos-opc3"> Sí, mucha dificultad. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-difManos-opc4"
                                    name="mano"
                                    checked={formData.mano === 'R4'}
                                    value="R4"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />

                                <label className="form-check-label" htmlFor="radio-difManos-opc4"> No puedo hacerlo. </label>
                            </div>
                        </fieldset>
                    </div>
                     <div id="ayuda-formato-tipo" className="form-text">
                            <p style={{ color: validError.mano ? 'red' : 'gray' }}>
                                {validError.mano ? validError.mano : ''}
                            </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="frecAnsiedad" className="mb-3">
                            <legend id="frecAnsiedad">9. ¿Con qué frecuencia se siente muy ansioso, nervioso o preocupado?</legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-frecAnsiedad-opc1"
                                    name="ansia"
                                    checked={formData.ansia === 'R1'}
                                    value="R1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-frecAnsiedad-opc1"> No, nunca. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-frecAnsiedad-opc2"
                                    name="ansia"
                                    checked={formData.ansia === 'R2'}
                                    value="R2"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />

                                <label className="form-check-label" htmlFor="radio-frecAnsiedad-opc2"> Algunas veces al año. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-frecAnsiedad-opc3"
                                    name="ansia"
                                    checked={formData.ansia === 'R3'}
                                    value="R3"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />

                                <label className="form-check-label" htmlFor="radio-frecAnsiedad-opc3"> Cada mes. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-frecAnsiedad-opc4"
                                    name="ansia"
                                    checked={formData.ansia === 'R4'}
                                    value="R4"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />

                                <label className="form-check-label" htmlFor="radio-frecAnsiedad-opc4"> Todos los días. </label>
                            </div>
                        </fieldset>
                    </div>
                    <div id="ayuda-formato-tipo" className="form-text">
                            <p style={{ color: validError.ansia ? 'red' : 'gray' }}>
                                {validError.ansia ? validError.ansia : ''}
                            </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="frecTriste" className="mb-3">
                            <legend id="frecTriste">10. ¿Con qué frecuencia se siente muy triste o deprimido?</legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-frecTriste-opc1"
                                    name="triste"
                                    checked={formData.triste === 'N1'}
                                    value="N1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-frecTriste-opc1"> No, nunca. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-frecTriste-opc2"
                                    name="triste"
                                    checked={formData.triste === 'A1'}
                                    value="A1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-frecTriste-opc2"> Algunas veces al año. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-frecTriste-opc3"
                                    name="triste"
                                    checked={formData.triste === 'M1'}
                                    value="M1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-frecTriste-opc3"> Cada mes. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-frecTriste-opc4"
                                    name="triste"
                                    checked={formData.triste === 'D1'}
                                    value="D1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />

                                <label className="form-check-label" htmlFor="radio-frecTriste-opc4"> Todos los días. </label>
                            </div>
                        </fieldset>
                    </div>
                     <div id="ayuda-formato-tipo" className="form-text">
                            <p style={{ color: validError.triste ? 'red' : 'gray' }}>
                                {validError.triste ? validError.triste : ''}
                            </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="certDiscapacidad" className="mb-3">
                            <legend id="certDiscapacidad">11. ¿Tiene Certificación de Discapacidad emitido por el Consejo Nacional de Discapacidad de República Dominicano?</legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-certDiscapacidad-opc1"
                                    name="certificado"
                                    checked={formData.certificado === 'S1'}
                                    value="S1"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-certDiscapacidad-opc1"> Sí. </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-certDiscapacidad-opc2"
                                    name="certificado"
                                    checked={formData.certificado === 'S2'}
                                    value="S2"
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-certDiscapacidad-opc2"> No. </label>
                            </div>
                        </fieldset>
                    </div>
                        <div id="ayuda-formato-tipo" className="form-text">
                            <p style={{ color: validError.certificado ? 'red' : 'gray' }}>
                                {validError.certificado ? validError.certificado : ''}
                            </p>
                    </div>
                </div>

                <span className="separador"></span>

                <div className="form-botones">
                    <Button children="Guardar" onClick={handleSubmit} variant='primary'></Button>                   
                </div>

            </form>
            <Toaster position="top-center" reverseOrder={false} />
            {/* Modal */}
                <ConfirmModal />
                <IncompleteModal />
            {/* Fin Modal */}
        </div>
    )
};


export default Paso4;